import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as cloneDeep from 'lodash/cloneDeep';
import { CheckAuthToken } from 'src/app/handler/auth-check';
import { AUTHGWCONSTANTS } from './authorization/authconstatnts';
import { AppService } from './app.service';
import { BuildConfig } from 'src/app/handler/build-config';
import { Util } from './util/util';
import { StaticMemory } from 'src/app/handler/static_memory';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LocationSetDialogComponent } from './element-widgets/location-set-dialog/location-set-dialog.component';
import { PopupDialogComponent } from './element-widgets/popup-dialog/popup-dialog.component';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppService],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  buildVersion: String = environment.version + '+' + environment.versionCode;
  vHostUrl = environment.proxyApiUrl;
  currentYear = new Date().getFullYear();
  data: any = {};
  addressdata: any = null;
  shopObject: any = {};
  subCategoryArray: Array<any> = [];
  categoryArray: Array<any> = [];
  localStorageProduct: Array<any> = [];
  productObj: any = {};
  wishlistObj: any = {};
  cartItemCount: number = 0;
  wishlistCount: number = 0;
  loggedIn = false;
  loading = true;
  auth = new CheckAuthToken();
  searchInput: string = '';
  profileName: string = '';
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  showHome: boolean;
  name: string = '';
  selectedIndex: string = null;

  @ViewChild('top') topElement: ElementRef;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  @HostListener('window:scroll', [])
  onWindowScroll(): void {}
  businessProfile$ = new BehaviorSubject<any>(null);

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private service: AppService,
    private activatedroute: ActivatedRoute,
  ) {
    this.localStorageProduct = JSON.parse(localStorage.getItem(BuildConfig.productArray));
    this.service.onOnlineCartReload.subscribe((response: any) => {
      if (StaticMemory.isServiceArea) {
        if (this.service.updateHeaders()) {
          this.getCarts();
        }
      } else {
        AppService.globalCartCounter = 0;
      }
    });

    this.service.onOnlineWishlistReload.subscribe((response) => {
      if (StaticMemory.isServiceArea) {
        if (this.service.updateHeaders()) {
          this.getWishlists();
        }
      } else {
        AppService.globalWishlistCounter = 0;
      }
    });

    this.service.onOfflineCartReload.subscribe((response) => {
      this.onOfflineCartReload();
    });
  }

  ngOnInit(): void {
    const serviceArea = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.serAreaObject));
    const addressObj = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.addressObject));
    if (serviceArea) {
      StaticMemory.isServiceArea = true;
      StaticMemory.serAreaObject = serviceArea;
    }
    if (addressObj) {
      StaticMemory.addressObject = addressObj;
    }
    AppService.addressChange.subscribe((result) => {
      if (result) {
        this.addressdata = result;
      } else {
        this.addressdata = result;
      }
    });
    if (this.service.updateHeaders()) {
      this.onCheckAuth();
    }
    this.activatedroute.queryParams.subscribe((params) => {
      this.selectedIndex = params['pId'];
      this.searchInput = params.search || '';
    });
    setTimeout(() => {
      this.loading = false;
      this.loadScripts();
    }, 500);
  }

  onCheckAuth(): void {
    const guestCheck = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);
    const authCheck = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);

    if (authCheck && authCheck.length) {
      CheckAuthToken.loggedIn = true;
      this.loggedIn = true;
      this.getProfile();
      this.getBusinessProfile();
      this.getAddress();
      this.getParentCategories();
    } else {
      CheckAuthToken.loggedIn = false;
      this.loggedIn = false;
      const cartCount = JSON.parse(localStorage.getItem(BuildConfig.cartCount));
      const wishCount = JSON.parse(localStorage.getItem(BuildConfig.wishCount));
      if (cartCount) {
        this.cartItemCount = cartCount;
      }
      if (wishCount) {
        this.wishlistCount = wishCount;
      }
      if (!guestCheck) {
        this.getGuestToken();
      } else {
        this.getBusinessProfile();
        this.getParentCategories();
      }
    }
  }

  onChangeAddress(): void {
    if (StaticMemory.isServiceArea) {
      const data = {
        location_message: '',
        type: 1,
      };
      this.openLocationSetDialog(data);
    } else {
      this.openAlertDialog();
    }
  }

  getGuestToken(): void {
    this.service.getGuestToken().subscribe(
      (success) => {
        if (success.status && success.result && success.result) {
          localStorage.setItem(AUTHGWCONSTANTS.guestAuth, success.result[0]);
          if (this.service.updateHeaders()) {
            this.getBusinessProfile();
            this.getParentCategories();
          }
        }
      },
      (error) => {},
    );
  }

  getAddress(): void {
    this.service.getAddress().subscribe(
      (success) => {
        if (success.status && success.result && success.result) {
          if (success.result.length === 1) {
            localStorage.setItem(AUTHGWCONSTANTS.addressObject, JSON.stringify(success.result[0]));
            StaticMemory.addressObject = success.result[0];
            this.addressdata = success.result[0];
          } else {
            for (let i = 0; i < success.result.length; i++) {
              if (success.result[i].default) {
                localStorage.setItem(
                  AUTHGWCONSTANTS.addressObject,
                  JSON.stringify(success.result[i]),
                );
                StaticMemory.addressObject = success.result[i];
                this.addressdata = success.result[i];
              }
            }
          }
          this.getServiceArea();
        } else {
          const data = {
            location_message: success.message,
          };
          this.openLocationSetDialog(data);
        }
      },
      (error) => {},
    );
  }

  getServiceArea(): void {
    const value = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.addressObject));
    const urlParams: any = {
      latitude: value.latitude,
      longitude: value.longitude,
    };
    if (value.location) {
      urlParams.latitude = value.location['co-ordinates'][1];
      urlParams.longitude = value.location['co-ordinates'][0];
    }
    this.service.getServiceArea(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          localStorage.setItem(AUTHGWCONSTANTS.serAreaObject, JSON.stringify(success.result[0]));
          StaticMemory.serAreaObject = success.result[0];
          StaticMemory.isServiceArea = true;
          if (this.localStorageProduct && this.localStorageProduct.length) {
            for (let i = 0; i < this.localStorageProduct.length; i++) {
              this.productObj = cloneDeep({});
              this.productObj.isOrdered = false;
              this.productObj.subProductId = this.localStorageProduct[i].subproductId;
              this.productObj.selectedQuantity = this.localStorageProduct[i].selectedQuantity;
              // this.productObj.cashback = this.localStorageProduct[i].cashBackAmount;
              this.productObj.cashback = 0;
              if (this.localStorageProduct[i].cashBack) {
                if (this.localStorageProduct[i].discountType === 'CENT') {
                  this.productObj.cashback =
                    (this.localStorageProduct[i].price / 100) *
                    this.localStorageProduct[i].discount;
                  this.productObj.cashback *= this.productObj.selectedQuantity;
                  if (this.localStorageProduct[i].discountUpto) {
                    if (this.productObj.cashback >= this.localStorageProduct[i].discountUpto) {
                      this.productObj.cashback = this.localStorageProduct[i].discountUpto;
                    }
                  }
                } else {
                  this.productObj.cashback =
                    this.localStorageProduct[i].discount * this.productObj.selectedQuantity;
                }
              }
              if (StaticMemory.isServiceArea) {
                this.postProductInCart();
              }
            }
          }
          if (this.service.updateHeaders()) {
            if (StaticMemory.isServiceArea) {
              this.getCarts();
              this.getWishlists();
            }
          }
        } else {
          localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
          const data = {
            location_message: success.message,
          };
          if (!this.addressdata) {
            this.openLocationSetDialog(data);
          }
        }
      },
      (error) => {},
    );
  }

  onOfflineCartReload(): void {
    let cartCounter = 0;
    const value = JSON.parse(localStorage.getItem(BuildConfig.productArray));
    if (value) {
      for (let i = 0; i < value.length; i++) {
        cartCounter += value[i].selectedQuantity;
      }
    }
    this.cartItemCount = cartCounter;
  }

  getParentCategories(): void {
    this.service.getParentCategories().subscribe((success) => {
      if (success.status && success.result && success.result.length) {
        success.result.forEach((item: any) => {
          this.categoryArray.push(item);
        });
        this.subCategoryArray = success.result[0].subCategoriesInfo;
        this.activatedroute.queryParams.subscribe((paramsOrg) => {
          const catId = paramsOrg.catId;
          const selectedCategory = this.subCategoryArray.find((cat) => cat._id === catId);
          if (!selectedCategory) {
            this.shopObject.selectCategoryType = this.categoryArray[0]._id;
          }
        });
      }
    });
  }

  updateQueryParam(pCat: string, cCat: string): void {
    this.selectedIndex = pCat;
    let updatedUrl = Util.replaceURLParameter(this.router.url, 'pId', pCat);
    updatedUrl = Util.replaceURLParameter(updatedUrl, 'catId', cCat);
    Util.changeURLWithoutReloadWithRouter(this.router, updatedUrl);
    const queryParams = { pId: pCat, catId: cCat };
    // const urlSegment =
    //   this.router.url.includes('product') ||
    //   this.router.url.includes('cart') ||
    //   this.router.url.includes('checkout') ||
    //   this.router.url.includes('wishlist') ||
    //   this.router.url.includes('orders') ||
    //   this.router.url.includes('my-account');
    // if (urlSegment) {
    this.router.navigate(['/shop'], { queryParams });
    // }
  }

  onSearch(): void {
    // this.router.navigate(['/shop'], { queryParams: { search: this.searchInput, pId: '', catId: '' } }).then(() => {
    //   this.scrollToTop();
    // });
    this.router.navigate(['/shop'], { queryParams: { search: this.searchInput } }).then(() => {
      this.scrollToTop();
    });
  }

  onKeyUpSearchClear(filterValue: string): void {
    if (!filterValue) {
      if (window.location.href.includes('/shop')) {
        this.router.navigate(['/shop'], { queryParams: { search: this.searchInput } }).then(() => {
          this.scrollToTop();
        });
      }
    }
  }

  onSearchClear(): void {
    this.searchInput = '';
    Util.changeURLWithoutReloadWithRouter(
      this.router,
      Util.replaceURLParameter(this.router.url, 'search', ''),
    );
  }

  onCloseMenu(): void {
    document.getElementById('close-menu').click();
  }

  getBusinessProfile(): void {
    this.service.getBusinessProfile().subscribe((success) => {
      if (success.status && success.result.length) {
        this.data = success.result[0];
        StaticMemory.businessProfileObject = success.result[0];
        this.businessProfile$.next(this.data);
        this.primaryColor = this.data.primaryColor;
        this.secondaryColor = this.data.secondaryColor;
        this.tertiaryColor = this.data.tertiaryColor;
        this.showHome = this.data.showHome;
        if (this.data?.systemSettings && Object.keys(this.data?.systemSettings).length) {
          const idx = this.data?.systemSettings;
          if (idx.cod !== undefined || idx.cod !== null) {
            this.data.cod = idx.cod;
          }
        }
        this.data.primaryLogoLink = '';
        if (this.data.logo && this.data.logo.length) {
          this.data.primaryLogoLink = this.data.logo[0]?.linkMd;
        }
        if (this.data.footerLogo && this.data.footerLogo.length) {
          this.data.footerLogoLink = this.data.footerLogo[0].linkMd;
        }
        if (this.data.secondaryLogo && this.data.secondaryLogo.length) {
          this.data.secondaryLogoLink = this.data.secondaryLogo[0].linkMd;
        }

        if (this.data.fevicon && this.data.fevicon.length) {
          this.data.favIcon =
            environment.proxyApiUrl +
            '/uploads/' +
            this.data._id +
            '/entity_fevicon/' +
            this.data._id +
            '/' +
            this.data.fevicon[0].time +
            this.data.fevicon[0].mimeType;
        }
        this.favIcon.href = this.data.favIcon;
        this.data.lat_text = 0;
        if (this.data.location) {
          const value = this.data.location.coordinates;
          this.data.lat_text = value[0];
        }
        this.data.long_text = 0;
        if (this.data.location) {
          const value = this.data.location.coordinates;
          this.data.long_text = value[1];
        }
      }
    });
  }

  onMapInfo(lat: number, long: number): void {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${long}`;
    window.open(googleMapsUrl, '_blank');
  }

  getProfile(): void {
    this.service.getProfile().subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          StaticMemory.profileDetails = success.result[0];
          localStorage.setItem(
            AUTHGWCONSTANTS.profile,
            JSON.stringify(StaticMemory.profileDetails),
          );
          this.profileName = StaticMemory.profileDetails.firstName;
        }
      },
      (error: any) => {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/']);
      },
    );
  }

  getCarts(): void {
    const urlParams: any = {
      serviceAreaId: StaticMemory.serAreaObject?._id,
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
      channel: environment.defaultChannel,
    };
    let vCartCounter = 0;
    this.service.getCarts(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          const result = success.result;
          for (const idx of result) {
            vCartCounter += idx.selectedQuantity;
          }
        }
        this.cartItemCount = vCartCounter;
        AppService.globalCartCounter = this.cartItemCount;
      },
      (error: any) => {
        this.cartItemCount = vCartCounter;
        AppService.globalCartCounter = this.cartItemCount;
      },
    );
  }

  postProductInCart(): void {
    this.productObj.serviceAreaId = StaticMemory.serAreaObject?._id;
    this.productObj.warehouseId = StaticMemory.serAreaObject?.warehouseId;
    this.productObj.channel = environment.defaultChannel;
    this.service.postProductInCart(this.productObj).subscribe(
      (success) => {
        for (let i = 0; i < this.localStorageProduct.length; i++) {
          if (this.productObj.subProductId === this.localStorageProduct[i].subproductId) {
            this.localStorageProduct.splice(this.localStorageProduct[i], 1);
          }
        }
        if (!this.localStorageProduct || !this.localStorageProduct.length) {
          localStorage.removeItem(BuildConfig.cartCount);
          localStorage.removeItem(BuildConfig.productArray);
          if (this.service.updateHeaders()) {
            this.getCarts();
          }
        }
      },
      (error: any) => {
        for (let i = 0; i < this.localStorageProduct.length; i++) {
          if (this.productObj.subProductId === this.localStorageProduct[i].subproductId) {
            this.localStorageProduct.splice(this.localStorageProduct[i], 1);
          }
        }
        if (!this.localStorageProduct || !this.localStorageProduct.length) {
          localStorage.removeItem(BuildConfig.cartCount);
          localStorage.removeItem(BuildConfig.productArray);
          if (this.service.updateHeaders()) {
            this.getCarts();
          }
        }
      },
    );
  }

  getWishlists(): void {
    const urlParams: any = {
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
    };
    let wishCounter = 0;
    this.service.getWishlists(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          wishCounter = success.result.length;
        }
        this.wishlistCount = wishCounter;
        AppService.globalWishlistCounter = this.wishlistCount;
      },
      (error: any) => {
        this.wishlistCount = wishCounter;
        AppService.globalCartCounter = this.wishlistCount;
      },
    );
  }

  onSignin(): void {
    sessionStorage.removeItem('sign-object');
    this.router.navigate(['/auth/signin']);
  }

  onSignout(): void {
    localStorage.clear();
    this.router.navigate(['/auth/signin']).then(() => {
      window.location.reload();
    });
    this.onCheckAuth();
  }

  loadScripts(): void {
    const dynamicScripts = ['../assets/js/main.js'];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  openAlertDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '450px';
    dialogConfig.data = { title: 'Your address is not serviceable. Please update your address.' };
    const dialogRef = this.dialog.open(PopupDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (PopupDialogComponent.result) {
        const data = {
          location_message: '',
          type: 1,
        };
        this.openLocationSetDialog(data);
      }
    });
  }

  openLocationSetDialog(data: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '1000px';
    dialogConfig.data = data;
    this.dialog.open(LocationSetDialogComponent, dialogConfig);
  }
}
